module.exports = __webpack_public_path__ + "static/media/5.2aec73df.jpeg";